<template>
  <v-footer elevation="0">
    <v-container class="px-xl-15">
      <v-row class="px-3">
        <v-col cols="12" class="pa-0">
          <v-card
            width="100%"
            tile
            flat
            style="opacity: 0.5"
            class="d-flex justify-center flex-md-row flex-column"
          >
            <v-card-title class="text-center text-break">
            © کلیه حقوق برای موسسه مهرآوران دانش پژوهان البرز محفوظ می باشد
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style lang="scss" scoped></style>
